// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  DASHBOARD_DESKTOP_HEIGHT: 78,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 78 - 32,

  MAIN_DESKTOP_HEIGHT: 78,
  MAIN_DESKTOP_OFFSET_HEIGHT: 78 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 190,
  DASHBOARD_WIDTH: 190,
  DASHBOARD_COLLAPSE_WIDTH: 78,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 34,
  DASHBOARD_ITEM_SUB_HEIGHT: 30,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 20,
  NAVBAR_ITEM_HORIZONTAL: 18,
};

// SETTINGS
// ----------------------------------------------------------------------

export const cookiesExpires = 7;

export const cookiesKey = {
  themeMode: 'DIOManagerThemeMode',
  themeDirection: 'DIOManagerThemeDirection',
  themeColorPresets: 'DIOManagerThemeColorPresets',
  themeLayout: 'DIOManagerThemeLayout',
  themeStretch: 'DIOManagerThemeStretch',
};

export const defaultSettings = {
  themeMode: 'dark',
  themeDirection: 'ltr',
  themeColorPresets: 'purple',
  themeLayout: 'horizontal',
  themeStretch: true,
};
